import { render, staticRenderFns } from "./ReviewDesktopModal.vue?vue&type=template&id=1952e5c4&scoped=true&"
import script from "./ReviewDesktopModal.vue?vue&type=script&lang=js&"
export * from "./ReviewDesktopModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952e5c4",
  null
  
)

export default component.exports